export const confirmDialog = async ({ message, confirm, buttons, cancel, title }) => {
  return new Promise((resolve) => {
    const id = `dialog-${Math.floor(Math.random() * 10000)}`;
    const backingId = `dialog-backing-${Math.floor(Math.random() * 10000)}`;
    const template = `
      <div class="confirm-dialog-backing ${backingId}"></div>
      <div class="confirm-dialog ${id}">
         ${title ? `<div class="title">${title}</div>` : ``}    
         <div class="message">${message}</div>
         <div class="buttons ${!!buttons ? 'multiple' : ''}">
           ${!buttons ? `<button class="btn btn-primary" data-action="confirm">${confirm || 'Confirm'}</button>` : ``}
           ${
             !!buttons
               ? Object.entries(buttons)
                   .map(
                     ([key, value]) => `
                <button class="btn btn-primary" data-action="${key}">${value}</button>
              `
                   )
                   .join('')
               : ''
           }          
           ${
             cancel !== false
               ? `
               <button class="btn" data-action="cancel">
                 ${cancel || 'Cancel'}
               </button>
             `
               : ''
           }       
         </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', template);
    const dialog = document.querySelector(`.${id}`);
    const backing = document.querySelector(`.${backingId}`);
    setTimeout(() => {
      dialog.classList.add('active');
      backing.classList.add('active');
      setTimeout(() => {
        const action = buttons ? Object.keys(buttons)[0] : 'confirm';
        const confirmButton = document.body.querySelector(`button[data-action="${action}"]`);
        if (confirmButton) {
          confirmButton.focus();
        }
      }, 300);
    }, 100);
    const close = (confirm) => {
      backing.removeEventListener('click', handleBackingClick);
      dialog.removeEventListener('click', handleButtonClick);
      window.removeEventListener('keypress', handleWindowKeypress);
      window.removeEventListener('keydown', handleWindowKeydown);
      dialog.classList.remove('active');
      backing.classList.remove('active');
      resolve(confirm);
      setTimeout(() => {
        dialog.remove();
        backing.remove();
      }, 300);
    };
    const handleWindowKeydown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        close(false);
      }
    };
    const handleWindowKeypress = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    const handleBackingClick = () => {
      close('cancel');
    };
    const handleButtonClick = (e) => {
      if (e.target.nodeName === 'BUTTON') {
        const action = e.target.getAttribute('data-action');
        let result = action === 'confirm' ? true : action === 'cancel' ? false : action;
        close(result);
      }
    };
    window.addEventListener('keypress', handleWindowKeypress);
    window.addEventListener('keydown', handleWindowKeydown);
    dialog.addEventListener('click', handleButtonClick);
    backing.addEventListener('click', handleBackingClick);
  });
};

export default confirmDialog;
